import { render, staticRenderFns } from "./pdf-image.vue?vue&type=template&id=fca8d910&scoped=true"
import script from "./pdf-image.vue?vue&type=script&lang=js"
export * from "./pdf-image.vue?vue&type=script&lang=js"
import style0 from "./pdf-image.vue?vue&type=style&index=0&id=fca8d910&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca8d910",
  null
  
)

export default component.exports